require('./contractAresLoanStep2.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// @commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @components
const ContractAresLoanINEModal = require('./contractAresLoanINEModal/contractAresLoanINEModal');
const ContractLoanPdfViewerError = require('../../contractLoanPdfViewerError/contractLoanPdfViewerError');
// @actions
const { getHiringDocuments, sendAresPreContractualMail } = require('../../../../actions/contractAresLoan');
// @constants
const translations = require('./contractAresLoanStep2.translations');
const { API_CENTER, API_ENTERPRISE_NUMBER } = require('constants/index');
const { MULTIPLE_OPERATIONS, messages: { OPERATION_PAYROLL_GDPR, OPERATION_PAYROLL_NO_GDPR } } = require('constants/operationTypes');
const { retailLoanProposition: { FORMALIZE_OPERATION } } = require('../../../../loansConstants/index');
// @utilities
const BrowserUtils = require('utilities/browserUtils');
const { downloadAsFile } = require('utilities/APIRequestHelper');
const { formatCurrency, decimalsLength, formatAmount, getFormattedString } = require('utilities/currencyHelper');
const { mapContractingData, mapDocumentsRequest, mapPrecontractualMailRequest } = require('../contractAresLoanHelper');
const { getTaeInfo } = require('../../../../loansUtilities/loansHelper');
const { recordLinkV2, recordPath, PAGE_GENERIC, PAGE_CONTRACT_ARES_LOAN_STEP2 } = require('utilities/tagging');

class ContractAresLoanStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openINEModal: false,
            sentPrecontractualEmail: false,
        }

        this.getDocuments = this.getDocuments.bind(this);
        this.handleOpenINEModal = this.handleOpenINEModal.bind(this);
        this.handleCloseINEModal = this.handleCloseINEModal.bind(this);
    }

    componentDidMount() {
        this.getDocuments();
    }

    componentWillUnmount() {
        const { agreeCheckbox, onAgreeCheckbox } = this.props;
        if (agreeCheckbox) onAgreeCheckbox();
    }

    getDocuments() {
        const { dossier, paymentDayType, selectedAccount, getHiringDocuments } = this.props;
        getHiringDocuments(mapDocumentsRequest(dossier, paymentDayType, selectedAccount));

    }

    buildSummary() {
        const contractingData = mapContractingData(this.props.dossier.get('contractingData'), this.props.paymentDayType);

        const rawAmount = contractingData.get('selectedAmount');
        const rawArrangementFee = contractingData.get('arrangementFee');
        const rawCurrency = contractingData.get('currency');

        const currency = formatCurrency(rawCurrency);
        const decimalsLengthLoanImport = decimalsLength(rawAmount);
        const decimalsArragementFee = decimalsLength(rawArrangementFee);
        const arrangementFee = formatAmount(rawArrangementFee, decimalsArragementFee);

        const summary = [
            {
                id: 'loanAmountLabel',
                value: getFormattedString({
                    amount: rawAmount,
                    currency,
                    decimalsLength: decimalsLengthLoanImport
                }),
                typeStyle: 'medium'
            },
            {
                id: 'timeLimitLabel',
                value: formatText(translations.TERMS_LABEL_DESCRIPTION, [contractingData.get('selectedTerm')]),
                typeStyle: 'small'
            },
            {
                id: 'monthlyQuotaLabel',
                value: getFormattedString(contractingData.get('installment')),
                typeStyle: 'medium'
            },
            {
                id: 'openingCommissionLabel',
                additionalLabel: (<sup>1</sup>),
                value: `${arrangementFee} ${currency}`,
                extra: contractingData.get('arrangementPercentage'),
                typeStyle: 'large'
            }
        ];

        const elements = summary.map((item, index) => {
            return (
                <li className={`contract-ares-loan-step-two__list-element contract-ares-loan-step-two__list-element--${item.typeStyle}`}
                    key={`element-${index}`}>
                    <FormattedText
                        value={`${translations.BASE}${item.id}`}
                        injectedStrings={[item.extra]}
                    />
                    {item.additionalLabel ? item.additionalLabel : null }
                    <p className="contract-ares-loan-step-two__list-element-value">
                        {item.value}
                    </p>
                </li>
            );
        });

        return (
            <ul className="contract-ares-loan-step-two__list">
                {elements}
            </ul>
        );
    }

    handleOpenINEModal() {
        recordLinkV2({ categoriaEvento: PAGE_CONTRACT_ARES_LOAN_STEP2, accionEvento: "abrir", etiquetaEvento: "leer" });
        this.setState({ openINEModal: true });
    }

    handleCloseINEModal(canContinue = false) {
        const { sentPrecontractualEmail } = this.state;
        const { dossier, paymentDayType, selectedAccount, onAgreeCheckbox, sendAresPreContractualMail } = this.props;
        const acceptedText = formatText(translations.PDF_VIEWER_CHECKBOX);
        recordPath(PAGE_CONTRACT_ARES_LOAN_STEP2, PAGE_GENERIC, 'contratacion-prestamo-ares', 'paso_2');

        recordLinkV2({ categoriaEvento: PAGE_CONTRACT_ARES_LOAN_STEP2, accionEvento: "salir" });
        this.setState({ openINEModal: false, sentPrecontractualEmail: true }, () => {
            if (canContinue) {
                onAgreeCheckbox();
                if (!sentPrecontractualEmail) {
                    sendAresPreContractualMail(mapPrecontractualMailRequest(dossier, paymentDayType, selectedAccount, acceptedText));
                }
            }
        });
    }

    buildReadAndAcceptLegalInfo() {
        const { agreeCheckbox } = this.props;
        return (
            <div className="contract-ares-loan-step-two__read-legal-info">
                <OKBoxTitle value={formatText(translations.LEGAL_INFO_TITLE)} isNotSeparator />
                {agreeCheckbox ? (
                    <div className="contract-ares-loan-step-two__read-legal-info__content-read">
                        <OKButton
                            onClick={this.handleOpenINEModal}
                            modifier={'link-emphasize'}
                        >
                            <FormattedText value={translations.LEGAL_INFO_DESCRIPTION} />
                        </OKButton>
                        <div className={`contract-ares-loan-step-two__read-legal-info__read-button`}>
                            <i className="signature-pattern-code-input__icon icon icon-check"/>
                            <FormattedText value={translations.LEGAL_INFO_READ_BUTTON} />
                        </div>
                    </div>
                ) : (
                    <div className="contract-ares-loan-step-two__read-legal-info__content">
                        <p className="contract-ares-loan-step-two__read-legal-info__description">
                            <FormattedText value={translations.LEGAL_INFO_DESCRIPTION} />
                        </p>
                        <OKButton
                            onClick={this.handleOpenINEModal}
                            modifier={'secondary'}
                        >
                            <FormattedText value={translations.LEGAL_INFO_BUTTON} />
                        </OKButton>
                    </div>
                )}
            </div>
        );
    }

    handlePrintDocuments(documents) {
        recordLinkV2({ categoriaEvento: PAGE_CONTRACT_ARES_LOAN_STEP2, accionEvento: "clickPrint", etiquetaEvento: "legalContract" });

        const data = [new Uint8Array(documents)];
        const blobObject = new Blob(data, { type: 'application/pdf' });

        if (BrowserUtils.browserIsIE()) {
            window.navigator.msSaveOrOpenBlob(blobObject);
        } else {
            const blobURL = window.URL.createObjectURL(blobObject);
            const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
                'resizable,screenX=50,screenY=50,width=850,height=1050';
            const printWindow = window.open(blobURL, '', winparams);

            if (printWindow) {
                printWindow.print();
            }
        }
    }

    handleDownloadDocuments(documents, filename = 'document.pdf') {
        recordLinkV2({ categoriaEvento: PAGE_CONTRACT_ARES_LOAN_STEP2, accionEvento: "clickButton", etiquetaEvento: "downloadLegalContractButton" });
        downloadAsFile(documents, 'application/pdf', filename);
    }

    buildINEModal() {
        const { openINEModal } = this.state;
        const { agreeCheckbox, immContractAresLoan } = this.props;

        const documents = immContractAresLoan.get('INELink');
        const isLoading = immContractAresLoan.get('isFetching');
        const error = immContractAresLoan.get('error');

        return (
            <ContractAresLoanINEModal
                isOpenModal={openINEModal}
                onCloseModal={this.handleCloseINEModal}
                documents={documents}
                isFetching={isLoading}
                error={error}
                agreeCheckbox={agreeCheckbox}
                getDocuments={this.getDocuments}
                handleDownloadDocuments={() => this.handleDownloadDocuments(documents.body, 'INE_Document_ARES_Loan.pdf')}
                handlePrintDocuments={() => this.handlePrintDocuments(documents.body)}
            />
        );
    }

    buildContractAndSignaturePattern() {
        const { agreeCheckbox, immContractAresLoan, dossier, paymentDayType, selectedAccount } = this.props;
        // contract
        const documents = immContractAresLoan.get('policyLink');
        const isLoading = immContractAresLoan.get('isFetching');
        const error = immContractAresLoan.get('error');
        // signature
        const contractingData = dossier.get('contractingData');
        const proposalData = contractingData.get('proposalData');
        const taeInfo = getTaeInfo(contractingData, paymentDayType);
        const ammount = (taeInfo && taeInfo.get('totalAmount') ) || contractingData.get('amount');
        const currency = contractingData.get('currency');
        const propositionYear = proposalData.get('proposal').get('year');
        const propositionNumber = proposalData.get('proposal').get('proposalNumber');
        const accountProduct = selectedAccount.get('newProduct');
        const accountContract = selectedAccount.get('newContractNumber');
        const operationParams = [{
            ammount,
            currency,
            serviceCode: FORMALIZE_OPERATION,
            optional1: API_ENTERPRISE_NUMBER + API_CENTER + propositionYear + propositionNumber,
            originAccount: API_ENTERPRISE_NUMBER + API_CENTER + accountProduct + accountContract
        }];

        if (agreeCheckbox && isLoading) {
            return <LoadingSection />;
        }

        return (
            agreeCheckbox 
            ? 
                <React.Fragment>
                    <OKPdfViewer
                        title={formatText(translations.CONTRACT_VIEWER_TITLE)}
                        pdfFile={documents && documents.body || ''}
                        onDownload={() => this.handleDownloadDocuments(documents.body, 'Contract_Document_ARES_Loan.pdf')}
                        onPrint={() => this.handlePrintDocuments(documents.body)}
                        showScroll
                        onDocumentReaded={() => this.setState({ scrollFinalDone: true })}
                        failedLoadingPdf={error}
                        errorComponent={() => {
                            return <ContractLoanPdfViewerError getDocuments={this.getDocuments} />
                        }}
                    />
                    <div className="contract-ares-loan-step-two__margin-separator"></div>
                    <GDPRSignaturePattern
                        operationType={MULTIPLE_OPERATIONS}
                        operationParams={operationParams}
                        multiOTPGDPRMessageCode={OPERATION_PAYROLL_GDPR}
                        multiOTPMessageCode={OPERATION_PAYROLL_NO_GDPR}
                    />
                </React.Fragment>
            : null
        );
    }


    render() {
        const title = formatText(translations.TITLE);
        const description = formatText(translations.DESCRIPTION);
        const summary = this.buildSummary();
        const legalInfo = this.buildReadAndAcceptLegalInfo();
        const INEModal = this.buildINEModal();
        const contractAndSignature = this.buildContractAndSignaturePattern();

        return (
            <section>
                <h2 className="contract-ares-loan-step-two__title">
                    {title}
                </h2>
                <p className="contract-ares-loan-step-two__message">
                    {description}
                </p>
                {summary}
                <div>
                    <OKConsents placementId="contractPayrollLoan" />
                </div>
                <div className="contract-ares-loan-step-two__separator"></div>
                {legalInfo}
                {INEModal}
                {contractAndSignature}
            </section>
        );
    }
}

ContractAresLoanStep2.propTypes = {
    dossier: PropTypes.object.isRequired,
    paymentDayType: PropTypes.string.isRequired,
    selectedAccount: PropTypes.object.isRequired,
    // Contract and INE documents
    immContractAresLoan: PropTypes.object.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    // precontractual mail
    sendAresPreContractualMail: PropTypes.func.isRequired,
    // agree Checkbox
    agreeCheckbox: PropTypes.bool.isRequired,
    onAgreeCheckbox: PropTypes.func.isRequired,
};

module.exports = connect(state => ({
    immContractAresLoan: state.contractAresLoan
}),
{
    getHiringDocuments: getHiringDocuments,
    sendAresPreContractualMail: sendAresPreContractualMail,
})(ContractAresLoanStep2);
